module.exports = "<p>\n  backorder-details-modal works!\n</p>\n"